import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { PencilIcon } from '@motorway/mw-highway-code';
import { Radio } from '@motorway/mw-highway-code/alpha';

import texts from 'Components/VehicleList/VehicleListV2/VehicleListV2.texts.json';
import { triggerSavedSearchItemHoverEvent } from 'Services/analytics/events';
import type { SavedFilter } from 'Types/savedFilter';

import styles from '../SavedSearchesFlow.module.scss';

const LocalT = new MDText(texts.savedSearchModals);

interface ListViewProps {
	onEditRow: (id: number) => void;
	onSelect: (id: number) => void;
	savedFilters: SavedFilter[];
	selectedId?: number;
}

export const ListView: FC<ListViewProps> = ({ onEditRow, onSelect, savedFilters, selectedId }) => (
	<div className={styles.list}>
		{savedFilters.map((filter) => (
			<div
				key={filter.id}
				className={styles.row}
				onFocus={() => triggerSavedSearchItemHoverEvent()}
				onMouseEnter={() => triggerSavedSearchItemHoverEvent()}
			>
				<div className={styles.radioWrapper}>
					<Radio
						fullWidth
						formProps={{
							input: {
								checked: selectedId === filter.id,
								onChange: () => onSelect(filter.id),
								readOnly: true,
							},
						}}
						id={String(filter.id)}
						label={filter.name}
						variant="default"
					/>
				</div>
				<button
					aria-label={`${LocalT.translate('editAriaLabel', { name: filter.name })}`}
					className={styles.editRowButton}
					onClick={() => onEditRow(filter.id)}
					type="button"
				>
					<PencilIcon />
				</button>
			</div>
		))}
	</div>
);
